import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ComboBox, InputWithLabel, LineItem } from '@reveni-io/reveni-ui'

import { weightUnits } from '@/common/constants'

import * as Styles from './styles'

const LineItemCustomsInfo = ({ lineItem, regions, onChange }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const handleOnChange = (field, value) => {
    if (field === 'country_code') {
      onChange({ ...lineItem?.customsInfo, country: { code: value } })
    } else {
      onChange({ ...lineItem?.customsInfo, [field]: value })
    }
  }

  const getHsCodeError = () => {
    if (lineItem?.customsInfo?.hs_code?.length < 6) {
      return t('Formato no válido')
    }
  }

  return (
    <Styles.LineItemContainer>
      <LineItem
        key={lineItem?.id}
        item={lineItem}
        options={{
          showStatus: false,
          showReason: false,
          showActionType: false,
        }}
      />
      <Styles.Container>
        <ComboBox
          label={t('País de origen')}
          value={lineItem?.customsInfo?.country?.code}
          handleChange={e => handleOnChange('country_code', e.target.value)}
          menuItems={regions?.map(region => ({
            value: region.code,
            label: region.name,
          }))}
          backgroundColor={theme.colors.background.primary}
        />
        <Styles.FieldsContainer>
          <InputWithLabel
            label={t('SKU')}
            value={lineItem?.customsInfo?.sku}
            onChange={e => handleOnChange('sku', e.target.value)}
            backgroundColor={theme.colors.background.primary}
            disabled={lineItem?.sku}
            helperText={!lineItem?.sku && t('Es obligatorio añadir el SKU')}
            fullWidth
          />
          <InputWithLabel
            label={t('HS Code')}
            value={lineItem?.customsInfo?.hs_code}
            onChange={e => handleOnChange('hs_code', e.target.value)}
            backgroundColor={theme.colors.background.primary}
            error={getHsCodeError()}
            helperText={getHsCodeError()}
            fullWidth
          />
          <InputWithLabel
            label={t('Peso')}
            type="number"
            value={Number(lineItem?.customsInfo?.weight) || ''}
            onChange={e => handleOnChange('weight', e.target.value)}
            backgroundColor={theme.colors.background.primary}
            fullWidth
          />
          <ComboBox
            value={lineItem?.customsInfo?.weight_unit}
            handleChange={e => handleOnChange('weight_unit', e.target.value)}
            menuItems={weightUnits.map(unit => ({
              label: t(unit.label),
              value: unit.value,
            }))}
            backgroundColor={theme.colors.background.primary}
            fullWidth
          />
        </Styles.FieldsContainer>
      </Styles.Container>
    </Styles.LineItemContainer>
  )
}

export default LineItemCustomsInfo
